import { render, staticRenderFns } from "./PromotionPlacement.vue?vue&type=template&id=3f0cee7c"
import script from "./PromotionPlacement.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotionPlacement.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports